import { render, staticRenderFns } from "./additionalField.vue?vue&type=template&id=f5f397c2"
import script from "./additionalField.vue?vue&type=script&lang=js"
export * from "./additionalField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports